import {
  fetchGetPikJk,
  IGetPikJkResponse,
  IGetPikJkResponse200,
  IGetPikJkResponse400,
} from '../../repositories/monolith-python/v1/get-pik-jk';
import { IHttpApi } from '@cian/http-api';
import { assertNotFoundError } from './assert/assertNotFoundError';
import { IPikData } from '../../../typings/api';

export const getGetPikJk = async ({ httpApi }: { httpApi: IHttpApi }): Promise<IPikData> => {
  const response = await fetchGetPikJk<IGetPikJkResponse200, IGetPikJkResponse400>({ httpApi, parameters: {} });

  assertNotFoundError(response);

  const pikJk: IGetPikJkResponse = (response as IGetPikJkResponse200).response;

  return {
    status: pikJk.status,
    data: {
      jkObjects: pikJk.data.jkObjects || [],
      filtersData: pikJk.data.filtersData || {},
      bannerObjects: pikJk.data.bannerObjects || [],
      locations: pikJk.data.locations || [],
      officeObjects: pikJk.data.officeObjects || [],
    },
  } as IPikData;
};
